export var VideoProviderEvents;
(function (VideoProviderEvents) {
    VideoProviderEvents["Exception"] = "exception";
    VideoProviderEvents["ConnectionCreated"] = "connectionCreated";
    VideoProviderEvents["ConnectionDestroyed"] = "connectionDestroyed";
    VideoProviderEvents["LocalStream"] = "localStream";
    VideoProviderEvents["LocalStreamDestroyed"] = "localStreamDestroyed";
    VideoProviderEvents["MOSChange"] = "MOSChange";
    VideoProviderEvents["MOSUpdate"] = "MOSUpdate";
    VideoProviderEvents["PublisherMOSUpdate"] = "PublisherMOSUpdate";
    VideoProviderEvents["GetUserMediaError"] = "getUserMedia:error";
    VideoProviderEvents["GetUserMediaSuccess"] = "getUserMedia:success";
    VideoProviderEvents["SessionConnected"] = "sessionConnected";
    VideoProviderEvents["SessionDisconnected"] = "sessionDisconnected";
    VideoProviderEvents["StreamCreated"] = "streamCreated";
    VideoProviderEvents["StreamDestroyed"] = "streamDestroyed";
    VideoProviderEvents["UpdatePeople"] = "updatePeople";
})(VideoProviderEvents || (VideoProviderEvents = {}));
